<template>
  <div>
    <div class="temp-work-value-div table-responsive mx-0">
      <table class="temp-work-value-table">
        <thead class="sticky-thead">
          <tr>
            <th
              v-for="inquireField in inquireFields"
              style="min-width: 140px; font-size: 1rem"
            >
              {{ inquireField }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="inquireItem in inquireItems">
            <tr>
              <td rowspan="2">{{ inquireItem.time }}</td>
              <td>設定值</td>
              <td v-for="setValue in inquireItem.value.set">
                {{ setValue }}
              </td>
            </tr>
            <tr>
              <td>實際值</td>
              <td v-for="(actValue, act) in inquireItem.value.act">
                {{ actValue }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { watch } from "@vue/runtime-core";
export default {
  components: {},
  props: {
    inquireFields: Array,
    inquireItems: Array,
  },
  setup(props) {
    // //參數table
    // const paramFields = ref(["", "", "一區", "二區", "三區", "四區"]);
    // const paramItems = ref([
    //   {
    //     time: "2023-03-27 01:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 02:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 03:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 04:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 05:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 06:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 07:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 08:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 09:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 10:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    //   {
    //     time: "2023-03-27 11:00",
    //     value: { set: [650, 650, 650, 650], act: [700, 700, 700, 700] },
    //   },
    // ]);
    // //設置相關資料
    // const setTempData = (tempData) => {
    //   if (tempData.value != undefined) {
    //     paramItems.value = tempData.value;
    //   } else {
    //     paramItems.value = [];
    //   }
    // };
    // watch(
    //   () => props.inquireData,
    //   (newValue) => {
    //     console.log(newValue);
    //     setTempData(newValue);
    //   },
    //   { deep: true }
    // );
    // return {
    //   paramFields,
    //   paramItems,
    // };
  },
};
</script>

<style scoped>
.temp-work-value-div {
  overflow-y: auto;
  height: 450px;
  /* width: 100%; */
  /* min-width: 900px; */
}

.temp-work-value-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #999;
}

.temp-work-value-table > thead > tr > th {
  padding: 5px;
  font-size: 1rem;
  color: #000;
  background-color: #ccc;
  border: 0.1px solid #999;
  min-width: 30px;
  height: 2.8rem;
  font-weight: 400;
}

.sticky-thead {
  position: sticky;
  top: 0px;
}

.temp-work-value-table tbody td {
  border: 0.1px solid #999;
  height: 2.8rem;
  font-weight: 400;
}
</style>
